import React from 'react';
import { format, isToday, isYesterday } from 'date-fns';
import { TrashIcon } from '@radix-ui/react-icons';

import { formatTimeOfDay } from '../../../core/services/date.service';

import type { Asset } from '../../../app/entities/asset';

import styles from './version-manager-item.module.scss';
export interface VersionManagerItemProps {
  version: Asset;
  isSelected?: boolean;
  canDelete?: boolean;
}

export const VersionManagerItem: React.FC<VersionManagerItemProps> = ({
  version,
  isSelected = false,
  canDelete = true,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['version-text']} data-is-selected={!!isSelected}>
        v{version.version}
      </div>

      <img className={styles['asset-thumbnail']} src={version.cover?.src} />

      <div className={styles['version-details']}>
        <h3 className={styles['version-title']} data-is-selected={!!isSelected}>
          {version.name}
        </h3>
        <p className={styles['version-uploader-and-time']}>
          {version.uploaderName}
          {' - '}
          {version.createdAt && isToday(new Date(version.createdAt))
            ? 'Today'
            : isYesterday(new Date(version.createdAt))
            ? 'Yesterday'
            : format(new Date(version.createdAt), 'MMM dd, yyyy')}
          , {version.createdAt && formatTimeOfDay(new Date(version.createdAt))}
        </p>
      </div>

      {canDelete && (
        <div className={styles['delete-button']} onClick={() => version.delete()}>
          <TrashIcon />
        </div>
      )}
    </div>
  );
};
